import { render } from "./DialogDeleteStock.vue?vue&type=template&id=2b8eda74&scoped=true"
import script from "./DialogDeleteStock.vue?vue&type=script&lang=js"
export * from "./DialogDeleteStock.vue?vue&type=script&lang=js"

import "./DialogDeleteStock.vue?vue&type=style&index=0&id=2b8eda74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8eda74"]])

export default __exports__